export const homeGoods = {
  // 家乡菜二级页-一级分类点击
  clickTab: 'n.5228.94.0',
  // 家乡菜二级页-商品曝光
  goodExpose: 'n.5228.7711.0',
  // 家乡菜二级页-选规格点击
  chooseFormate: 'n.5228.96.0',
  // 家乡菜二级页-收起点击
  chooseFormateClose: 'n.5228.97.0',
  // 家乡菜二级页-加购物车点击
  goodAdd: 'n.5228.10.0',
  // 家乡菜二级页-减购物车点击
  miniCart: 'n.5228.11.0',
  // 家乡菜二级页-跳转详情点击
  goodMin: 'n.5228.262.0',

  // 家乡菜二级页-选家乡弹窗曝光
  chooseHomeExpose: 'n.5228.11024.0',

  // 家乡菜二级页-选省市区-关闭按钮点击
  chooseAreaClose: 'n.5228.11027.0',
  // 家乡菜二级页-选省市区-返回按钮点击
  chooseAreaBack: 'n.5228.11028.0',

  // 家乡菜二级页-选家乡弹窗-去选家乡点击
  chooseHomeClick: 'n.5228.11025.0',
  // 家乡菜二级页-选家乡弹窗-关闭按钮点击
  chooseHomeClose: 'n.5228.11026.0',
  // 家乡菜二级页-选省市区-保存并查看家乡菜按钮点击
  chooseAreaSave: 'n.5228.11029.0',
  clickFloatCart: 'n.5228.8970.0'
}
